import React from 'react';
import { ForgotPassword } from 'components';

function ForgotPasswordComponent() {
    return <ForgotPassword />;
}

export default ForgotPasswordComponent;
